<template>
  <div>
    <PageTitle v-bind:title="title" v-bind:admin="false" />
    <div class="row justify-content-center py-5">
      <div class="col-12 col-md-8">
        <div class="card p-5">
          <div class="alert alert-danger" v-if="error">
            {{ error }}
          </div>
          <form @submit.prevent="submit">
            <div class="form-group">
              <label for="email" class="col-form-label">Email</label>
              <input
                type="text"
                name="email"
                id="email"
                v-model="form.email"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label for="password" class="col-form-label">Password</label>
              <input
                type="password"
                name="password"
                id="password"
                v-model="form.password"
                class="form-control"
              />
            </div>
            <div class="form-group text-center">
              <button type="submit" class="btn btn__primary">Вход</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import PageTitle from "@/components/PageTitle";

export default {
  name: "signin",
  components: {
    PageTitle,
  },
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      error: "",
      title: "Вход",
    };
  },
  methods: {
    ...mapActions({
      signIn: "auth/signIn",
    }),
    submit() {
      this.error = "";
      this.signIn(this.form)
        .then(() => {
          //console.info('SignIn: Добро пожаловать!')
          this.$router.replace({
            name: "dashboard",
          });
        })
        .catch(() => {
          this.error =
            "Ошибка при входе. Возможно, указаны неверные данные для входа!";
        });
    },
  },
};
</script>